import * as Yup from "yup";

const Validation = Yup.object().shape({
  type: Yup.string()
    .required("Type is required")
    .oneOf(["Ethnicity", "Style", "Breast", "Butt", "Accent"], "Invalid type selected"),
  name: Yup.string()
    .required("Modal Name is required")
    .min(2, "Modal Name must be at least 2 characters long")
    .max(50, "Modal Name can't exceed 50 characters"),
});
export default Validation; 